// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'af456892-e722-4c6a-8142-d07cf140935c',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'ffcb4df4-d4cd-4a25-b564-04471780710a',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'af456892-e722-4c6a-8142-d07cf140935c'
    },
    {
      id: '5120fb26-ba7b-49a0-8613-7b65b97c9a08',
      type: 'Container',
      name: 'rewardBubbleSlot',
      className: '',
      x: 0,
      y: -115,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'af456892-e722-4c6a-8142-d07cf140935c'
    },
    {
      id: 'd3372980-0c61-45f7-a48c-a9d289a34e80',
      type: 'Container',
      name: 'rewardSpawnPoint',
      className: '',
      x: 0,
      y: -200,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'af456892-e722-4c6a-8142-d07cf140935c'
    },
    {
      id: 'b8bb1ae2-f1ec-4a24-9763-dc811bd489f8',
      type: 'Sprite',
      name: 'shadow',
      className: '',
      x: -14,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Chest_Shadow',
      parent: 'ffcb4df4-d4cd-4a25-b564-04471780710a'
    },
    {
      id: '2cf7d8bc-9722-4f4e-bce9-9e77ceaf15fc',
      type: 'Container',
      name: 'chestContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'ffcb4df4-d4cd-4a25-b564-04471780710a'
    },
    {
      id: 'a488699b-f886-43e9-abb8-4aefef541ab4',
      type: 'Sprite',
      name: 'chest',
      className: 'chestSprite',
      x: -10,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.7
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Chest_Closed',
      parent: '2cf7d8bc-9722-4f4e-bce9-9e77ceaf15fc',
      stateByName: {
        opened: {
          texture: 'Win_Streak_Chest_Open',
          y: -10,
          x: -23
        }
      }
    },
    {
      id: 'c390310e-638b-4dd6-b91d-a6637ecbbdae',
      type: 'Sprite',
      name: 'chestOverlay',
      className: 'chestSprite',
      x: -5,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.7
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Chest_Closed',
      parent: '2cf7d8bc-9722-4f4e-bce9-9e77ceaf15fc'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    'opened'
  ],
  animations: [
    {
      id: '6567704f-e95d-4920-9837-391ddbdec0d7',
      name: 'Win_Streak_Chest_Idle',
      playingSpeed: 1,
      totalDuration: 5000,
      blocks: [
        {
          id: '6fa28999-0b9a-49f8-aec1-69fb287873f9',
          type: 'Setter',
          name: 'chestOpenAlpha',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'chestOpen',
          disabled: false
        },
        {
          id: '23036169-793a-4d59-897c-5c33cf65f9e7',
          type: 'Setter',
          name: 'chestOverlayAlpha',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'chestOverlay',
          disabled: false
        },
        {
          id: '843eda9c-c156-4dbe-b8f5-d831b70546d0',
          type: 'Setter',
          name: 'chestOpenOverlayAlpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'chestOpenOverlay',
          disabled: false
        },
        {
          id: '07115679-fced-4eee-9c2b-09bec73073c4',
          type: 'Tween',
          name: 'chestScale_1',
          duration: 300,
          track: 3,
          target: {
            scale: {
              x: 0.95,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2311ee71-eb48-4c77-8425-e99cba21997a',
          type: 'Tween',
          name: 'chestScale_3',
          duration: 300,
          track: 3,
          target: {
            scale: {
              x: 1.05,
              y: 0.95
            }
          },
          startAt: 300,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a9d1b676-a1c1-4b75-9f37-f38fa2a77073',
          type: 'Tween',
          name: 'chestScale_2',
          duration: 300,
          track: 3,
          target: {
            scale: {
              x: 0.95,
              y: 1.05
            }
          },
          startAt: 600,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '851566b6-1ff4-4b66-b752-81d3bce528fe',
          type: 'Tween',
          name: 'chestScale',
          duration: 300,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 900,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'cfc6839c-8434-4239-9389-eda3dc033160',
      name: 'Win_Streak_Chest_Open',
      playingSpeed: 1,
      totalDuration: 1100,
      blocks: [
        {
          id: '34d25fcd-3ebd-4183-be55-b341d40e29ba',
          type: 'Setter',
          name: 'chestOverlayAlpha',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'chestOverlay',
          disabled: false
        },
        {
          id: '35cc4e1f-6ae2-4f2b-8349-08ad1ee8dd73',
          type: 'Setter',
          name: 'chestOpenOverlayAlpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'chestOpenOverlay',
          disabled: false
        },
        {
          id: '52883741-3fda-49c5-b098-f0a8cd4df0a7',
          type: 'Setter',
          name: 'chestOpenAlpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'chestOpen',
          disabled: false
        },
        {
          id: '4885a319-bf25-4b43-ba73-05e2ec6fbc1c',
          type: 'Tween',
          name: 'chestScale_4',
          duration: 150,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 0,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f22ed7f1-0903-463d-9456-614dd977f81a',
          type: 'Tween',
          name: 'shadowAlpha',
          duration: 150,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'shadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '41f98eef-dc04-4763-8a6a-f0ab47333609',
          type: 'Tween',
          name: 'chestPosition_2_copy',
          duration: 300,
          track: 3,
          target: {
            y: -80
          },
          startAt: 150,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5e07f512-c051-4c1b-816d-7cb34d6afb1f',
          type: 'Tween',
          name: 'chestScale_6',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 150,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '16bd2cac-e4f7-483d-8c1c-4352be8eeb8e',
          type: 'Tween',
          name: 'chestRotation',
          duration: 300,
          track: 4,
          target: {
            angle: -10
          },
          startAt: 150,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a4e5b6ba-5227-4974-8b23-a98f415c53c9',
          type: 'Tween',
          name: 'New_tween',
          duration: 150,
          track: 5,
          target: {
            alpha: 0.4
          },
          startAt: 250,
          sourceName: 'chestOverlay',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '773aa331-8a91-41a0-aa88-a683210293dc',
          type: 'Setter',
          name: 'ANIMEVENT_spawnGifts',
          track: 9,
          target: {},
          startAt: 400,
          sourceName: 'rewardBubbleSlot',
          disabled: false
        },
        {
          id: '301048fc-ec44-44d5-977e-d7d3323d0680',
          type: 'Setter',
          name: 'chestOverlayTextureChange',
          track: 5,
          target: {
            textureName: 'Win_Streak_Chest_Open',
            x: -18,
            y: -8
          },
          startAt: 400,
          sourceName: 'chestOverlay',
          disabled: false
        },
        {
          id: '0c3a3f84-3ee8-4a5c-89c3-4f9e2356d47f',
          type: 'Setter',
          name: 'textureChange',
          track: 8,
          target: {
            textureName: 'Win_Streak_Chest_Open',
            y: -8,
            x: -18
          },
          startAt: 400,
          sourceName: 'chest',
          disabled: false
        },
        {
          id: '73f0c1b2-5767-40e0-b54d-0ef5f397469f',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 240,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 410,
          sourceName: 'chestOverlay',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'bcc75d7c-edf0-4356-bc50-5cf65d9ec992',
          type: 'Tween',
          name: 'chestScale_7',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 450,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '899e1ccc-5c09-4523-a73d-eac4204fdad8',
          type: 'Tween',
          name: 'chestRotation_1',
          duration: 200,
          track: 4,
          target: {
            angle: 0
          },
          startAt: 600,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '01cdc0e2-198f-4792-ba4f-eabd82893294',
          type: 'Tween',
          name: 'chestPosition_2',
          duration: 200,
          track: 3,
          target: {
            y: 0
          },
          startAt: 600,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'bf2606ce-4ab8-425c-8aa2-87b5c0c01673',
          type: 'Tween',
          name: 'shadowAlpha_1',
          duration: 150,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 720,
          sourceName: 'shadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a384a77f-fe63-4426-9cd7-c93c7260af08',
          type: 'Tween',
          name: 'chestScale_8',
          duration: 150,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 750,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '636c3043-1e77-4d85-a62d-cd18355a9f4b',
          type: 'Tween',
          name: 'chestScale_9',
          duration: 150,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 900,
          sourceName: 'chestContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class WinStreakChestLayout {
  static raw = raw;
  root!: Container;
  wrapper!: Container;
  rewardBubbleSlot!: Container;
  rewardSpawnPoint!: Container;
  shadow!: Sprite;
  chestContainer!: Container;
  chest!: Sprite;
  chestOverlay!: Sprite;
  chestSprite!: (Sprite)[];
  StateName!: 'opened';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Win_Streak_Chest_Idle {
  Layout: {
    chestOpen: object;
    chestOverlay: object;
    chestOpenOverlay: object;
    root: object;
  };

  BlockTypeByName: {
    chestOpenAlpha: object;
    chestOverlayAlpha: object;
    chestOpenOverlayAlpha: object;
    chestScale_1: object;
    chestScale_3: object;
    chestScale_2: object;
    chestScale: object;
  };

  flowData = raw.animations[0];
}

export abstract class Win_Streak_Chest_Open {
  Layout: {
    chestOverlay: object;
    chestOpenOverlay: object;
    chestOpen: object;
    chestContainer: object;
    shadow: object;
    rewardBubbleSlot: object;
    chest: object;
  };

  BlockTypeByName: {
    chestOverlayAlpha: object;
    chestOpenOverlayAlpha: object;
    chestOpenAlpha: object;
    chestScale_4: object;
    shadowAlpha: object;
    chestPosition_2_copy: object;
    chestScale_6: object;
    chestRotation: object;
    New_tween: object;
    ANIMEVENT_spawnGifts: object;
    chestOverlayTextureChange: object;
    textureChange: object;
    New_tween_1: object;
    chestScale_7: object;
    chestRotation_1: object;
    chestPosition_2: object;
    shadowAlpha_1: object;
    chestScale_8: object;
    chestScale_9: object;
  };

  flowData = raw.animations[1];
}
